(function(angular){
	'use strict';
	
	var opinionPollObject = {
		bindings: {
			pollQuestion: '<',
			useUrlParam: '<'
		},
		controller: [
			'$filter',
			'$timeout',
			'$rootScope',
			'STATIC_BASE_PATH',
			'localStorageFactory',
			'mixpanelFactory',
			'urlFactory',
			OpinionPollFunction
		],
		controllerAs: 'opinionPoll',
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		]
	};
	
	angular
		.module('investorUpdatesModule')
		.component('opinionPoll', opinionPollObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/opinion-poll/opinion-poll.html';
	}

	function OpinionPollFunction(
		$filter,
		$timeout,
		$rootScope,
		STATIC_BASE_PATH,
		localStorageFactory,
		mixpanelFactory,
		urlFactory
	) {
		var opinionPoll = this;
		var localStorageKey;
		var pollAnswerIdFromUrl;

		opinionPoll.$onInit = function() {
			pollAnswerIdFromUrl = urlFactory.getUrlParamAsNumber('opinionPollAnswerId');
			localStorageKey = "com.fundrise.poll-question." + opinionPoll.pollQuestion.id;
			opinionPoll.viewState = 'question';
			opinionPoll.selectedAnswerId = localStorageFactory.getItemAsNumber(localStorageKey);

			if(angular.isDefined(pollAnswerIdFromUrl)) {
				if(opinionPoll.useUrlParam) {
					if(angular.isDefined(opinionPoll.selectedAnswerId)) {
						opinionPoll.viewState = 'results';
					} else {
						opinionPoll.submitAnswer(pollAnswerIdFromUrl);
					}
				} else {
					if(!angular.isDefined(opinionPoll.selectedAnswerId)) {
						opinionPoll.selectedAnswerId = pollAnswerIdFromUrl;
					}
					showPollResponseModal();
					opinionPoll.viewState = 'results';
				}
			} else {
				if(angular.isDefined(opinionPoll.selectedAnswerId)) {
					opinionPoll.viewState = 'results';
				}
			}
		};

		opinionPoll.submitAnswer = function(answerId) {
			var answer = $filter('filter')(opinionPoll.pollQuestion.answers, { id: parseInt(answerId) }, true)[0];

			mixpanelFactory.track('Poll Question Answered', {
				'Question': opinionPoll.pollQuestion.text,
				'Question ID': opinionPoll.pollQuestion.id,
				'Answer': answer.text,
				'Answer ID' : answer.id,
				'Question Access Medium': angular.isDefined(pollAnswerIdFromUrl) ? 'External Link' : 'Investor Update Embed'
			});

			localStorageFactory.setItem(localStorageKey, answer.id);

			opinionPoll.selectedAnswerId = answer.id;

			recalculatePercentages(answer);
			transitionToResults();
		};

		function showPollResponseModal() {
			$rootScope.ModalFactory.showModal({
				templateUrl: STATIC_BASE_PATH + '/' + 'static/html/opinion-poll/opinion-poll-modal.html',
				controller: 'OpinionPollModal',
				controllerAs: 'opinionPollModal',
				inputs: {
					opinionPoll: opinionPoll.pollQuestion
				}
			});
		}

		function recalculatePercentages(answer) {
			answer.count += 1;
			opinionPoll.pollQuestion.totalResponseCount += 1;
			
			opinionPoll.pollQuestion.answers.forEach(function(answer) {
				answer.percentage = answer.count / opinionPoll.pollQuestion.totalResponseCount;
			});
		}

		function transitionToResults() {
			opinionPoll.viewState = 'thankYou';
			$timeout(function() {
				opinionPoll.viewState = 'results';
			}, 1000);
		}
	}
})(window.angular);